import { useSelector } from 'react-redux';
import { RootState } from '../../redux/reducers';

export default function useUserId(): number | undefined {
  return useSelector((state: RootState) => state.application.userId);
}
